// extracted by mini-css-extract-plugin
module.exports = {"app__header":"bl_fH","app__footer":"bl_bQ","app__flex_row":"bl_fJ","app__content__list":"bl_fK"};